import React from "react";
import { BedDouble, Wifi, ParkingCircle, Users, Coffee, Snowflake, Package } from "lucide-react";

export const AmenityIcon = ({ icon }) => {
  switch (icon) {
    case "Wifi":
      return <Wifi className="h-5 w-5" />;
    case "ParkingCircle":
      return <ParkingCircle className="h-5 w-5" />;
    case "Snowflake":
      return <Snowflake className="h-5 w-5" />;
    case "Users":
      return <Users className="h-5 w-5" />;
    case "Coffee":
      return <Coffee className="h-5 w-5" />;
    case "Package":
      return <Package className="h-5 w-5" />;
    default:
      return <BedDouble className="h-5 w-5" />;
  }
};
